const endpoints = {
	get: "/cart.json",
	add: "/cart/add.js",
	update: "/cart/update.js",
	change: "/cart/change.js",
};

const fetchCart = (shouldOpen = true) => {
  fetch(endpoints.get)
    .then(response => response.json())
    .then(data => {
      const elCounts = document.querySelectorAll('[data-cart-count]');
      const elDrawer = document.querySelector('cart-drawer');
      const isCartTemplate = !!document.querySelector('[data-cart-template]');
      const openCart = !isCartTemplate && shouldOpen;

      elCounts.forEach(el => el.innerHTML = `${data.item_count}`);
      openCart && elDrawer.setAttribute('open', true);

      window.cart = data;
      window.renderCart();
      console.log(data);
      return data;
    })
    .catch(err => {
      console.log(err);
      return err;
    })
}

const postCart = async (data, endpoint) => {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  const json = await response.json();
  fetchCart();
  return json;
}

window.addToCart = data => postCart(data, endpoints.add);
window.updateCart = data => postCart(data, endpoints.update);
window.changeCart = data => postCart(data, endpoints.change);

const formatMoney = (number, precision = 2, thousands = ',', decimal = '.') => {
  if (isNaN(number) || number == null) {
    return 0;
  }

  if (precision == 0 && (number / 100.0) % 1 != 0) {
    number = (number / 100.0).toFixed(2);
  } else {
    number = (number / 100.0).toFixed(precision);
  }

  const { active: activeCurrency } = window.Shopify.currency;
  const currencySymbol =  window.currencies && window.currencies[activeCurrency] ? window.currencies[activeCurrency] : '$';

  let parts = number.split(".");
	let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `${currencySymbol}1` + thousands);
  let cents = parts[1] ? decimal + parts[1] : "";

  return `${currencySymbol}${dollars + cents}`;
}

class CartDrawer extends PopupModal {
  constructor() {
    super();

    this.open = this.getAttribute('open') == "true";
    
    this.elContent = this.querySelector('[data-content]');
    this.elEmpty = this.querySelector('[data-empty]');
    this.elCartTemplate = document.querySelector('[data-cart-template]');
    this.isCartTemplate = !!this.elCartTemplate;
    this.elCartBody = this.isCartTemplate ? this.elCartTemplate : this.elContent;

    this.bind();
    fetchCart(false);

    window.renderCart = this.renderCart.bind(this);
    window.toggleCart = this.toggleDrawer.bind(this);
  }

  bind() {
    this.elClose = this.querySelectorAll('[data-close]');
    this.elClose.forEach(el => {
      el.removeEventListener('click', window.toggleCart);
      el.addEventListener('click', window.toggleCart);
    });

    this.elRemove = this.elCartBody.querySelectorAll('[data-item-remove]');
    this.elRemove.forEach(el => {
      el.addEventListener('click', () => {
        const key = el.getAttribute('data-item-remove');
        const data = { updates: { [key]: 0 } };
        window.updateCart(data);
      })
    });

    this.elQuantity = this.elCartBody.querySelectorAll('quantity-picker');
    this.elQuantity.forEach(el => {
      el.addEventListener('change', (ev) => {
        const data = { updates: { [el.dataset.id]: el.querySelector('input').value } };
        el.setAttribute('loading', true);
        window.updateCart(data)
          .then(response => {
            el.setAttribute('loading', false);
          });
      })
    });
  }

  renderCart() {
    const isEmpty = window.cart.item_count == 0;
    if(isEmpty) {
      this.elCartBody.innerHTML = '';
      this.elCartBody.appendChild(this.elEmpty.content.cloneNode(true));
      this.bind();
    } else {
      this.elCartBody.innerHTML = this.itemsTemplate();
      this.bind();
    }
  }

  toggleDrawer(ev) {
    if(!this.isCartTemplate) {
      ev && ev.preventDefault();
      this.open = !this.open;
      this.setAttribute('open', this.open);
    }
  }

  itemsTemplate() {
    return `
      <ul class="cart-template--items">
        ${window.cart.items.map(item => {
          return `
            <li class="cart-item">
              <div class="cart-item--info">
                <div class="cart-item--header">
                  <h3 class="cart-item--title">
                    ${item.product_title}
                  </h3>
                  <strong class="cart-item--price">
                    ${formatMoney(item.final_line_price)}
                  </strong>
                </div>
                <ul class="cart-item--options">
                  ${item.options_with_values.map(option => `<li>${option.value}</li>`).join('')}
                </ul>
                <span class="cart-item--quantity">
                  x${item.quantity}
                </span>
                <div class="cart-item--actions">
                  <quantity-picker
                    quantity="${item.quantity}"
                    data-name="updates[]"
                    data-id="${item.key}"
                    data-title="${item.title}"
                    class="cart-item--quantity"
                  ></quantity-picker>
                  <button 
                    type="button"
                    data-item-remove="${item.key}"
                    class="cart-item--remove"
                  >
                    Delete
                  </button>
                </div>
              </div>
              <div class="cart-item--image">
                <figure>
                  <img src="${item.image}" width="104" alt="An image of ${item.title}" />
                </figure>
                <a href="${item.url}" class="cart-item--link">
                  View ${item.title}
                </a>
              </div>
            </li>
          `
        }).join('')}
      </ul>
      <form
        id="cart-form"
        action="/cart"
        method="post"
        class="cart-template--form"
      >
        <table class="cart-template--totals">
          <tbody>
            <tr>
              <th scope="row">Subtotal</th>
              <td>${formatMoney(window.cart.items_subtotal_price)}</td>
            </tr>
            <tr>
              <th scope="row">Shipping & Taxes</th>
              <td>Calculated at checkout</td>
            </tr>
          </tbody>
        </table>
        <input type="hidden" value="checkout" name="checkout" />
        <button type="submit" class="btn--fill cart-template--submit">
          Checkout
        </button>
        <a href="/cart" class="cart-template--cta">
          View Bag
        </a>
      </form>
    `
  }
}

customElements.define('cart-drawer', CartDrawer);